//takes in an array of objects describing inputs, returns the rendered component
import React, { useState, useEffect } from 'react';




const Chart = (props) => {

  return (
    <>
      <button>Chart</button>

    </>
  )
}


export default Chart;